import React, { useEffect, useRef, useState } from 'react'
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import CholaDarkLogo from '../Images/chola_logo.svg'
import Lang from '../Images/lang-dark.svg'
import IntroImg from '../Images/intro-img.svg'
import OtpIcon from '../Images/otp-icon.svg'
import OTPInput from 'react-otp-input'
import OTPImg from '../Images/otp-icon.svg'
import back from '../Images/Keyboard backspace.svg'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { setLoggedIn, setOtpTriggered, setShowLanguage } from './MandateSlice'
import axios from 'axios'
import Loader from './Loader'
import { useSnackbar } from 'notistack'
import MainImg from '../Images/intro-img.svg'

function OTP() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const [showOtp, setShowOtp] = useState(false)
    const [loader, setLoader] = useState(false)
    const [showErr, setShowErr] = useState(false)
    const { mobileNo, losId, mandateID, mandateType } = useSelector((state) => state.mandateInfo);
    // const [mobileNo, setMobileNo] = useState()
    const [otp, setOtp] = useState()
    const Ref = useRef(null);
    const [timer, setTimer] = useState("00:00:00");

    const getTimeRemaining = (e) => {
        const total =
            Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor(
            (total / 1000 / 60) % 60
        );
        const hours = Math.floor(
            (total / 1000 / 60 / 60) % 24
        );
        return {
            total,
            hours,
            minutes,
            seconds,
        };
    };

    const startTimer = (e) => {
        let { total, hours, minutes, seconds } =
            getTimeRemaining(e);
        if (total >= 0) {
            // update the timer
            // check if less than 10 then we need to
            // add '0' at the beginning of the variable
            setTimer(
                // (hours > 9 ? hours : "0" + hours) +
                // ":" +
                // (minutes > 9
                //     ? minutes
                //     : "0" + minutes) +
                // ":" +
                (seconds > 9 ? seconds : "0" + seconds)
            );
        }
    };

    const clearTimer = (e) => {
        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next
        setTimer("60");

        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };

    const getDeadTime = () => {
        let deadline = new Date();

        // This is where you need to adjust if
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + 60);
        return deadline;
    };

    // We can use useEffect so that when the component
    // mount the timer will start as soon as possible

    // We put empty array to act as componentDid
    // mount only
    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    useEffect(() => {
        if (timer === '00') {
            setShowOtp(true)
        }
    }, [timer]);
    const validateOtp = () => {
        if (otp) {
            if (/^[0-9]+$/.test(otp)) {
                setLoader(true)
                axios({
                    url: process.env.REACT_APP_API_COMMON + 'mandate/verifyotp',
                    method: 'post',
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
                    },
                    data:
                    {
                        // "mobile": mobileNo.toString(),
                        "otp": otp,
                        // "platform": "web"
                        "unique_id": mandateID,
                    }
                }).then((res) => {
                    setLoader(false)
                    if (res?.data?.message === "Logged in successfully") {
                        dispatch(setLoggedIn(true))
                        sessionStorage.setItem("id", mandateID)
                        navigate('/details')
                    }
                    else {
                        // enqueueSnackbar(res?.data?.message, {
                        //     variant: "error",
                        //     preventDuplicate: true,
                        //     autoHideDuration: 3000,
                        // });
                        setShowErr(res?.data?.message)
                    }
                }).catch((e) => {
                    setLoader(false)
                    setShowErr(e?.message)
                });
            }
            else {
                setShowErr("Special characters not allowed")
            }
        }
        else {
            setShowErr("Please Enter the OTP")
        }
    }
    const resendOtp = () => {
        setOtp()
        setShowErr(false)
        axios({
            url: process.env.REACT_APP_API_COMMON + 'mandate/otp',
            method: 'post',
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
            },
            data: {
                // "mobile": mobileNo.toString(),
                // "application_id": losId,
                "unique_id": mandateID,
                // "platform": "web",
                // "deviceId": "e3regrth",
                // "unique_id": mandateID,
            }
        }).then((res) => {
            setLoader(false)
            if (res?.data?.message === "OTP generated successfully") {
                setTimer("60");
                clearTimer(getDeadTime());
                setShowOtp(false)
            }
            else {
                // enqueueSnackbar(res?.data?.Message, {
                //     variant: "error",
                //     preventDuplicate: true,
                //     autoHideDuration: 3000,
                // });
                setShowErr(res?.data?.Message)
            }
        }).catch((e) => {
            setLoader(false)
            setShowErr(e?.message)
          });
    }
    useEffect(()=>{
        if(!mandateType){
            dispatch(setOtpTriggered(true))
            navigate('/login')
        }
    },[mandateType])
    // useEffect(()=>{

    // },[])
    return (
        <>
            {loader && <Loader />}
            {/* <div class="Banner">
                <div class="container Payment-way-page">
                    <div class="row">
                        <div class="col-12">
                            <a href="#" class="Lang" onClick={()=>{dispatch(setShowLanguage(true))}}><img src={Lang} /></a>
                            <div class="text-center brand">
                                <img src={cholaLogo} class="img-fluid mb-2" />
                                <p class="fw-semibold mb-5">Cholamandalam Investment and Finance Ltd</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <div class="contBg">
                                {showErr && <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                    {showErr}
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">✕</button>
                                </div>}
                                <div class="d-flex gap-2 align-items-center">
                                    <a href="#" >
                                        <img class="" src={back} onClick={() => { window.history.go(-1); return false; }} />
                                    </a>
                                    <span class="fs-5 fw-medium">Enter OPT</span>
                                </div>
                                <div class="text-center mt-5 mb-4">
                                    <img src={OTPImg} class="img-fluid" />
                                </div>
                                <p class="text-secondary">Chola has sent a temporary OTP to your
                                    Mobile Number <span class="fw-semibold">+91-{mobileNo}</span> (valid for {timer} seconds)</p>
                                <div class="d-flex gap-3 mb-4">
                                    <OTPInput
                                        value={otp}
                                        onChange={setOtp}
                                        numInputs={6}
                                        renderSeparator={<span style={{ width: "8px" }}></span>}
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle={{
                                            textAlign: "center",
                                            borderRadius: "8px",
                                            boxShadow: "none",
                                            width: "48px",
                                            height: "48px",
                                            background: "#fff",
                                            border: "1px solid #B3B3B3",
                                            fontWeight: "500",
                                            fontSize: "20px",
                                            color: "#333333"
                                        }}
                                    />
                                </div>
                                <div class="mb-3">
                                    <button class="btn Proceed_btn w-100" type="button" onClick={validateOtp}>Verify</button>
                                </div>
                                {showOtp && <div class="text-center">
                                    <p>Didn't receive the OTP? <a href="#" onClick={() => { resendOtp() }} class="fw-medium">Resend OTP</a></p>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div class="IndBg">
                <div class="bd-spacer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-7 text-center">
                                <h1 class="mb-3 d-lg-block d-md-none d-sm-none d-none">E - Nach<br /> Registration</h1>
                                <h1 class="mt-4 mb-1 d-lg-none d-md-block d-sm-block">E - Nach Registration</h1>
                                <img src={MainImg} class="logImg img-fluid" />
                            </div>
                            <div class="col-lg-5 col-sm-12 col-md-12 p-res">
                                <div class="LogBox">
                                    {showErr &&
                                        <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                            <p class="mb-1">{showErr}</p>
                                            <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                                        </div>
                                    }
                                    <div class="d-flex gap-3 align-items-center">
                                        {/* <a href="Login.html">
                                        <img class="" src="assets/Images/arrow.svg" />
                                    </a> */}
                                        <span class="fs-5 fw-medium">OTP</span>
                                    </div>
                                    <div class="text-center mb-4">
                                        <img src={OtpIcon} class="img-fluid" />
                                    </div>
                                    <p>Chola has sent a temporary OTP to your
                                        Mobile Number <span class="fw-semibold">+91-{mobileNo}</span> (valid for {timer} seconds)</p>
                                    <div class="d-flex text-center mb-4">
                                        <OTPInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={6}
                                            renderSeparator={<span style={{ width: "8px" }}></span>}
                                            renderInput={(props) => <input {...props} />}
                                            inputStyle={{
                                                textAlign: "center",
                                                borderRadius: "8px",
                                                boxShadow: "none",
                                                width: "44px",
                                                height: "44px",
                                                background: "#fff",
                                                border: "1px solid #B3B3B3",
                                                fontWeight: "500",
                                                fontSize: "20px",
                                                color: "#333333"
                                            }}
                                        />
                                    </div>
                                    <div class="mb-3">
                                        <button class="btn Proceed_btn w-100" type="button" onClick={validateOtp}>Verify
                                            OTP</button>
                                    </div>
                                    {showOtp &&
                                        <><div class="text-center">
                                            <p>Click <a href="#" onClick={() => { resendOtp() }} class="fw-medium">Here</a> for resend OTP </p>
                                        </div>
                                            <small class="text-secondary fst-italic mb-0">If you have not received the OTP, please contact
                                                nearest branch for more details.</small></>}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <nav class="navbar MenuTop fixed-top navbar-expand-lg">
                                    <div class="container d-flex">
                                        <a class="navbar-brand p-0 me-0">
                                            <img src={CholaDarkLogo} alt="Chola Logo" />
                                        </a>
                                        <ul class="navbar-nav">
                                            <li class="nav-item">
                                                {/* <a class="nav-link" onClick={() => { dispatch(setShowLanguage(true)) }}>
                                                    <img src={Lang} />
                                                </a> */}
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="container Payment-way-page">
                                    <div className="row">
                                        <div className="col-12 text-center mt-4 mb-4"> <img src={cholaLogo} className="img-fluid" alt="" />
                                            <p className="Pay_way mt-3">Cholamandalam Investment and <br />
                                                Finance Company Limited</p>
                                        </div>
                                    </div>
                                    <div class="col-12 justify-content-center" style={{ display: "flex" }}>
                                        <img src={OTPImg} class="img-fluid" alt="Logo" />
                                    </div>
                                    <div className="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <p style={{ fontSize: "14px" }}>Chola has sent a temporary OTP to you mobile number {mobileNo} (Valid for {timer} Seconds)</p>
                                        </div>
                                        <div class="inputfield mb-4">
                                            <OTPInput
                                                value={otp}
                                                onChange={setOtp}
                                                numInputs={6}
                                                renderSeparator={<span style={{ width: "8px" }}></span>}
                                                renderInput={(props) => <input {...props} />}
                                                inputStyle={{
                                                    borderRadius: "8px",
                                                    width: "52px",
                                                    height: "54px",
                                                    fontSize: "24px",
                                                    color: "black",
                                                    fontWeight: "400",
                                                    caretColor: "blue"
                                                }}
                                                focusStyle={{
                                                    border: "1px solid #CFD3DB",
                                                    outline: "none"
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2 ">
                                        <button className="btn btn-primary Proceed_btn" type="button" onClick={validateOtp}>Proceed</button>
                                    </div>
                                    {showOtp && <div class="col-12 justify-content-center text-center mt-4">
                                        <p><b type="button" onClick={() => { resendOtp() }}>Click Here</b> to resend OTP</p>
                                        <p>If you have not received the OTP, please contact nearest branch for more details.</p>
                                    </div>}
                                </div> */}
        </>
    )
}

export default OTP